import { Sparkles } from "lucide-solid";
import { type Component, Show } from "solid-js";
import { isAuthenticated } from "../../lib/auth";
import { Button } from "../ui/button";
import { chatOpen, setChatOpen } from "./chat-store";
import { ChatPanel } from "./ChatPanel";

const GATEWAY_BASE = (import.meta.env.VITE_AI_GATEWAY_BASE as string | undefined) ?? "";
const GATEWAY_KEY = (import.meta.env.VITE_AI_GATEWAY_KEY as string | undefined) ?? "";

export const ChatWidgetBroker: Component = () => {
  // Chỉ mount khi đã setup env (auth + gateway URL + key).
  const enabled = () => isAuthenticated() && !!GATEWAY_BASE && !!GATEWAY_KEY;
  return (
    <Show when={enabled()}>
      <Show when={chatOpen()}>
        <ChatPanel />
      </Show>
      <Show when={!chatOpen()}>
        <Button
          class="fixed bottom-4 left-4 z-50 h-12 w-12 rounded-full shadow-lg bg-blue-600 hover:bg-blue-700"
          size="icon"
          onClick={() => setChatOpen(true)}
          title="Open broker assistant (B)"
        >
          <Sparkles class="h-5 w-5" />
        </Button>
      </Show>
    </Show>
  );
};
